/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Component, EventEmitter, Input, Output } from "@angular/core";
var Alert = (function () {
    function Alert() {
        this.isSmall = false;
        this.type = "alert-info";
        this.closable = true;
        this.isAppLevel = false;
        this._closed = false;
        this._closedChanged = new EventEmitter(false);
        this.alertTypes = ["alert-info", "alert-warning", "alert-danger", "alert-success"];
    }
    Alert.prototype.close = function () {
        if (!this.closable) {
            return;
        }
        this._closed = true;
        this._closedChanged.emit(true);
    };
    Alert.prototype.open = function () {
        this._closed = false;
        this._closedChanged.emit(false);
    };
    Object.defineProperty(Alert.prototype, "alertType", {
        get: function () {
            if (this.alertTypes.indexOf(this.type) > -1) {
                return this.type;
            }
            return "alert-info";
        },
        enumerable: true,
        configurable: true
    });
    return Alert;
}());
export { Alert };
Alert.decorators = [
    { type: Component, args: [{
                selector: "clr-alert",
                template: "\n      <!--\n        ~ Copyright (c) 2016 VMware, Inc. All Rights Reserved.\n        ~ This software is released under MIT license.\n        ~ The full license information can be found in LICENSE in the root directory of this project.\n        -->\n\n      <div\n          *ngIf=\"!_closed\"\n          class=\"alert\"\n          [ngClass]=\"alertType\"\n          [class.alert-sm]=\"isSmall\"\n          [class.alert-app-level]=\"isAppLevel\">\n          <button type=\"button\" class=\"close\" aria-label=\"Close\" *ngIf=\"closable\" (click)=\"close()\">\n              <clr-icon aria-hidden=\"true\" shape=\"close\"></clr-icon>\n          </button>\n          <ng-content select=\".alert-item\"></ng-content>\n      </div>\n    "
            },] },
];
/** @nocollapse */
Alert.ctorParameters = function () { return []; };
Alert.propDecorators = {
    'isSmall': [{ type: Input, args: ["clrAlertSizeSmall",] },],
    'type': [{ type: Input, args: ["clrAlertType",] },],
    'closable': [{ type: Input, args: ["clrAlertClosable",] },],
    'isAppLevel': [{ type: Input, args: ["clrAlertAppLevel",] },],
    '_closed': [{ type: Input, args: ["clrAlertClosed",] },],
    '_closedChanged': [{ type: Output, args: ["clrAlertClosedChange",] },],
};
//# sourceMappingURL=alert.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/emphasis/alert/alert.js
// module id = 180
// module chunks = 4